const ar = {
  welcomeMessage: 'مرحباً بك ',
  home: 'الرئيسية',
  dashboard: 'لوحة المعلومات',
  electronicServices: 'الخدمات الإلكترونية',
  verificationServices: 'خدمات التحقق',
  furizatBillsVerification: 'التحقق من فواتير فرجت',
  error: 'خطأ',
  success: 'نجاح',
  verificationServiceDescription: 'هذه الخدمة تساعدك على التحقق من فواتير مبادرة فرجت',
  docIdCopiedSuccessfully: 'تم نسخ رقم الفاتورة بنجاح',
  billNumber: 'رقم الفاتورة',
  billDetails: 'بيانات الفاتورة',
  billDescription: 'وصف الفاتورة',
  validate: 'تحقق',
  completionPercentage: 'نسبة الإكتمال',
  notCompeleted: 'لم تكتمل بعد',
  compeleted: 'اكتملت',
  remainingAmount: 'المبلغ المتبقي',
  rial: 'ريال سعودى',
  active: 'سارية',
  back: 'عودة',
  backToVerify: 'تحقق جديد',
  backToVerificationServices: 'العودة لخدمات التحقق',
  donationViaEhsan: 'تبرع عبر منصة إحسان',
  billNumberPlaceholder: 'مثال: 12534',
  noMatchingResultsTitle: 'لا يوجد نتائج تطابق البيانات المدخلة',
  noMatchingResultsDescription: 'الرجاء التأكد من البيانات والمحاولة مجدداً.',
  verificationSuccess: 'تم التحقق بنجاح',

  validations: {
    onlyNumbers: 'الرجاء إدخال أرقام فقط',
    fieldIsRequired: 'هذا الحقل مطلوب',
    maxNumbersLength: 'أقصى عدد للأرقام هو {length}',
    furijatBillIsRequired: 'الرجاء إدخال رقم الفاتورة',
  },

  serverErrors: {
    invoiceNotFound: 'الفاتورة رقم {invoiceNumber} ليست ضمن مبادرة فرجت',
    USER_NOT_FOUND: 'المستخدم غير موجود الرجاء المحاولة مرة أخرى',
    sometingWentWrong: 'عفوا حدث خطأ ما الرجاء المحاولة فى وقت لاحق',
  },
};

export default ar;
